// Traditional Chinese (Hong Kong) translation generated on 2025-11-04
// 本檔由英文版自動轉換而成（香港用語），請按需要進一步校對。
export const common = {
  "home.awards.title": "獎項榮譽",
  "home.awards.pause": "暫停獎項輪播",
  "home.awards.play": "播放獎項輪播",
  "home.awards.financialAlgorithm": "金融算法領軍企業",
  "home.awards.asiaPacificGold": "亞太黃金交易領軍品牌",
  "home.awards.preciousMetals": "貴金屬交易公信力品牌",
  "home.awards.digitalFinance": "數字金融創新貢獻企業",
  "home.awards.quantitativeTrading": "量化交易技術優秀企業",
  'nav.home': '主頁',
  'nav.trading': '交易',
  'nav.markets': '市場',
  'nav.news': '新聞',
  'nav.about': '關於',
  'nav.contact': '聯絡',
  'nav.login': '登入',
  'nav.register': '註冊',
    'nav.license': '牌照資質',
  'hero.title': '高端黃金與白銀交易平台',
  'hero.subtitle': '香港持牌公司，為全球投資者提供安全、專業的貴金屬交易服務',
  'hero.cta.start': '開始交易',
  'hero.cta.learn': '下載MT5',
  'home.licenseHK': '香港持牌',
  'home.bankSec': '銀行級保安',
  'home.247s': '24/7 客服',
  'home.global': '全球視野',
  'home.tradingPlat': '交易平台',
  'home.tradingWith': '強大穩健的',
  'home.exp': '體驗專為貴金屬打造的世界級交易平台。MT5 提供機構級工具、閃電級執行，以及全面的市場分析功能。',
  'home.dlMT5': '下載 MT5',
  'home.watchDemo': '觀看示範',
  'home.tradingIns': '交易產品',
  'home.exeSpeed': '執行速度',
  'home.mktAccess': '市場接入',
  'home.uptime': '在線率',
  'home.allDevices': '適用於所有裝置',
  'home.mktInt': '市場資訊',
  'home.mktInt.desc': '即時掌握影響貴金屬交易的經濟事件與市場新聞',
  'home.lastUpdate': '最後更新',
  'home.ecoCal': '經濟日曆',
  'home.refresh': '重新整理',
  'home.currency': '貨幣',
  'home.events': '事件',
  'home.previous': '前值',
  'home.forecast': '預測',
  'home.actual': '實際',
  'home.mktNews': '市場新聞',
  'home.seeMore': '查看更多',
  'home.ecoData': '經濟數據由多個金融數據供應商提供 • 市場新聞來自頂尖金融媒體',
  'home.ac': '高級圖表功能',
'home.pta': '提供超過 80 種技術指標與分析工具的專業技術分析',
'home.mpa': '多平台存取',
'home.tsa': '可於桌面版、網頁版及手機應用無縫交易',
'home.st': '安全交易',
'home.bls': '銀行級加密技術，保障資料傳輸與儲存安全',
'home.247': '全天候市場接入',
'home.rtc': '隨時隨地連接全球貴金屬市場進行交易',
'home.at': '自動化交易',
'home.ea': '支援智能交易系統(EA)以實現演算法及自動化策略',
'home.lfe': '閃電級執行',
'home.ull': '超低延遲下單，提供具競爭力的點差與即時成交',
  'features.title': '為何選擇我們的平台',
  'features.security.title': '銀行級保安',
  'features.security.desc': '先進加密與多層保安機制，保障您的投資',
  'features.licensed.title': '全面持牌',
  'features.licensed.desc': '受香港監管，合規透明',
  'features.realtime.title': '即時交易',
  'features.realtime.desc': '即時市場數據與瞬時執行，把握最佳交易機會',
  'features.support.title': '24/7 客服',
  'features.support.desc': '專業多語團隊全年無休為您服務',
  'features.lmd': '即時市場數據',
  'features.rtp': '貴金屬即時價格',
  'markets.title': '即時市場價格',
  'markets.gold': '黃金',
  'markets.silver': '白銀',
  'markets.platinum': '鉑金',
  'markets.palladium': '鈀金',
  'markets.price': '價格',
  'markets.change': '變動',
  'markets.high': '24h 高位',
  'markets.low': '24h 低位',
  'markets.contractDetials': '合約詳情',
  'markets.contractDetials.desc': '貴金屬的全面合約規格與交易條件',
  'markets.tradingExample': '交易示例',
  'markets.goldExample': '黃金交易示例',
  'markets.silverExample': '白銀交易示例',
  'markets.instrument': '品種',
  'markets.lotSize': '手數',
  'markets.entPrice': '入場價',
  'markets.marReq': '所需保證金',
  'markets.pip': '點值',
  'markets.pmt': '貴金屬交易',
  'markets.ctt': '全面了解貴金屬交易的條款、條件與規格；掌握合約詳情、保證金要求及風險管理要點，以支援黃金與白銀投資。',
  'markets.vts': '查看交易規格',
  'markets.dcd': '下載合約詳情',
  'markets.ec': '執行速度',
  'markets.th': '交易時間',
  'markets.ms': '最小點差（pips）',
  'markets.ml': '最高槓桿',
  'markets.mr': '保證金要求',
  'markets.lo': '不同帳戶類型的槓桿選項與保證金要求',
  'markets.leverage': '槓桿',
  'markets.margin': '保證金',
  'markets.mind': '最低入金',
  'markets.mc': '保證金計算器',
  'markets.gmc': '黃金保證金計算',
  'markets.cp': '當前價格',
  'markets.cv': '合約價值',
  'markets.smc': '白銀保證金計算',
  'markets.rm': '風險管理',
  'markets.crm': '以全面工具與策略保護您的投資',
  'markets.rtg': '風險承受度指南',
  'markets.rd': '風險披露',
  'markets.tpm': '貴金屬交易存在重大虧損風險，未必適合所有投資者。過往表現不代表未來結果。',
  'markets.lcw': '槓桿既可為您帶來利潤，亦可能擴大損失。作出交易決定前，請審慎考慮投資目標、經驗水平及風險承受度。',
  'markets.ysb': '請充分了解與貴金屬交易相關的所有風險；如有疑問，請諮詢獨立財務顧問。',
  'markets.rfr': '閱讀完整風險披露',
  'markets.cra': '聯絡風險顧問',
  'markets.tho': '交易時間',
  'markets.moh': '貴金屬市場之運作時間與假期安排',
  'markets.wts': '每週交易時間表',
  'markets.note': '注意',
  'markets.atad': '所有時間均以 GMT+8 顯示。於主要假期或高波動期間，交易或會暫停。',
  'markets.hs': '假期安排',
  'markets.mclo': '市場休市',
  'markets.eclo': '提早收市',
  'markets.hn': '假期通告',
  'markets.thm': '國定假日期間，交易時間可能調整；請留意我們的公告。',
  'markets.cms': '當前市場狀態',
  'markets.mac': '市場目前開放交易',
  'markets.st': '伺服器時間（GMT+8）',
  'markets.ts': '交易規格',
  'markets.dtc': '黃金與白銀品種的詳細交易條件與規格',
  'markets.msp': '最小點差',
  'markets.minls': '最小手數',
  'markets.maxls': '最大手數',
  'markets.commission': '佣金',
  'markets.sls': '隔夜利息（多／空）',
  'markets.in': '重要提示',
  'markets.smv': '於高波動或重大新聞期間，點差可能擴大',
  'markets.sra': '隔夜利息每日更新，或因市況改變',
  'markets.mlm': '重大新聞時，最高槓桿可能被下調',
  'markets.ata': '所有時間以 GMT+8 顯示',
  'news.title': '最新市場新聞與分析',
  'news.subtitle': '緊貼專家觀點與市場動態',
  'news.readMore': '閱讀更多',
  'news.category.analysis': '市場分析',
  'news.category.news': '突發新聞',
  'news.category.insights': '專家觀點',
  'news.category.education': '教育',
  'news.date': '發布時間',
  'news.author': '作者',
  'home.partners.title': '合作夥伴',
  'home.partners.subtitle': '與全球領先的流動性、金融科技及交易基礎設施供應商合作。',
  'testimonials.title': '深受全球投資者信賴',
  'testimonials.client1.name': 'Marcus Weber',
  'testimonials.client1.location': '德國 • 法蘭克福',
  'testimonials.client1.text': '平台出價透明、執行可靠，保安功能令我充滿信心。',
  'testimonials.client2.name': 'Sophie Dubois',
  'testimonials.client2.location': '法國 • 巴黎',
  'testimonials.client2.text': '專業服務與具競爭力點差；多語支援團隊非常幫得手。',
  'testimonials.client3.name': 'Alessandro Rossi',
  'testimonials.client3.location': '意大利 • 米蘭',
  'testimonials.client3.text': '執行迅速、分析工具出色，值得認真進行貴金屬交易的人士推薦。',
  'footer.company': '公司',
  'footer.trading': '交易',
  'footer.support': '支援',
  'footer.legal': '法律',
  'footer.about': '關於我們',
  'footer.careers': '招聘',
  'footer.news': '新聞',
  'footer.platforms': '交易平台',
  'footer.education': '教育',
  'footer.analysis': '市場分析',
  'footer.help': '幫助中心',
  'footer.contact': '聯絡我們',
  'footer.faq': '常見問題',
  'footer.terms': '服務條款',
  'footer.privacy': '私隱政策',
  'footer.risk': '風險披露',
  'footer.copyright': '© 2024 GOLD Label Global Limited. 版權所有。',
  'footer.license': "於香港註冊成立的公司",
  'footer.riskwarning': '風險提示',
  'footer.disclaimer': '保證金交易屬槓桿式金融產品，可能導致損失超過您的存款。您並不實際擁有或持有任何相關基礎資產。交易前請仔細閱讀本公司的〈風險披露聲明〉。請務必充分了解涉及的風險，並審慎管理風險敞口。基於本網站或其內容而作出的任何行動或不作為所導致的結果，本公司概不承擔任何責任。',
  'footer.jurisdiction': "司法管轄區聲明",
  'footer.jurisdictionDisclaimer': "本網站所述服務僅向香港及美國以外的司法管轄區內之合資格客戶提供，並以客戶所在地的適用法律允許提供該等服務為前提。服務不向香港或美國居民提供，亦不向任何所在地法律或法規禁止提供該等服務的人士提供。本網站並非針對任何受限制司法管轄區的人士，亦不構成向該等人士作出任何要約、招攬或建議。",
  'footer.relatedEntity': '其他相關實體',
  'footer.saintLuciaEntity': 'Gold Label Global (SL) Limited 為於聖盧西亞註冊成立的國際商業公司，成立日期為 2026 年 9 月 4 日，公司註冊編號為 2026-00680。註冊辦事處：Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia。該註冊辦事處僅為履行法定及監管合規要求而設，並非公司的實際營業處所，亦不作營運、客戶到訪或通訊用途。',
  'footer.regNo': '公司註冊編號',
  'common.language': '語言',
  'common.loading': '載入中…',
  'common.error': '錯誤',
  'common.success': '成功',
  'common.close': '關閉',
  'common.save': '儲存',
  'common.cancel': '取消',
  'common.continue': '繼續',
  'common.back': '返回',
  'common.next': '下一步',
  'common.previous': '上一頁',
  'common.submit': '提交',
  'common.reset': '重設',
  'about.yearsOfExp': '多年經驗',
  'about.yearsOfExp.desc': '在貴金屬交易領域累積數十年專業',
  'about.dailyTrade': '每日交易量',
  'about.dailyTrade.desc': '香港每日黃金與白銀成交達 800 億港元',
  'about.satClients': '客戶滿意度',
  'about.satClients.desc': '服務遍及全球的眾多客戶與機構',
  'about.exeSpeed': '執行速度',
  'about.exeSpeed.desc': '閃電級交易執行技術',
  'about.ourAch': '我們的成就',
  'about.ourAch.desc': '以業界領先的表現，屢獲肯定',
  'about.companyProfile': '公司簡介',
  'about.about1': '關於 Gold Label Global',
  'about.about2': 'Gold Label Global Limited 為香港政府核准之有限公司，同時亦為香港黃金交易所成員。香港每日處理價值約 800 億港元之金銀交易，經驗領先全球。',
  'about.about3': 'Gold Label Global 管理團隊在金銀交易領域專注逾二十年，曾服務無數客戶與機構，處理之客戶交易金額以數百億計，深獲客戶與業界專業人士高度評價。',
  'about.about4': '我們致力為客戶提供快速、穩定與優質的交易環境；技術上採用國際級交易系統，並由頂尖技術團隊開發更強大與更全面的交易方案，令交易速度更快、更穩、更全面。',
  'about.about5': 'Gold Label Global 將繼續與您共創收益、共享繁榮。',
  'about.about6': '探索我們在貴金屬交易之路上的成長，以及我們對全球金融市場卓越表現的承諾。',
  'about.about7': '作為香港政府核准之有限公司及香港黃金交易所成員，我們每日處理約 800 億港元的金銀交易，交易經驗領先全球。',
  'about.proTeam': '專業團隊',
  'about.proTeam.desc': '管理團隊深耕金銀交易超過 20 年，服務眾多客戶與機構。',
  'about.proService': '專業服務',
  'about.proService.desc': '專業客服團隊提供 24 小時線上與流動客服，並就客戶問題提供針對性方案。',
  'about.sec': '安全至上',
  'about.sec.desc': '無交易對手風險，訂單直入市場，交易公開透明、更安全可靠。',
  'about.strict': '嚴格監管',
  'about.strict.desc': 'Gold Label Global 為香港商業交易場所，受香港政府監管，亦為香港商業交易協會成員。',
  'about.fastDes': '快速入金',
  'about.fastDes.desc': '提供 24 小時業務服務，秒級入金，即開即用。',
  'about.productSafe': '產品安全',
  'about.productSafe.desc': '涵蓋全球主要貴金屬產品，安全可靠。',
  'about.whyGLB': '為何選擇 Gold Label Global',
  'about.whyGLB.desc': '了解我們在貴金屬交易領域成為首選的關鍵優勢',
  'about.readyToStart': '準備好開始交易了嗎？',
  'about.join': '加入成千上萬信任 GOLD Label Global 的滿意客戶行列，滿足您的貴金屬交易需求。',
  'about.openTradingAcc': '開立交易帳戶',
  'about.contactTeam': '聯絡我們的團隊',
  'about.co': '合作共贏',
  'about.co.desc': '與客戶與持份者建立互利的長期夥伴關係',
  'about.safety': '安全保障',
  'about.safety.desc': '確保所有交易活動達致最高安全標準',
  'about.integrity': '誠信正直',
  'about.integrity.desc': '秉持最高誠信與透明度標準',
  'about.professional': '專業',
  'about.professional.desc': '以無與倫比的專業度提供卓越服務',
  'about.fast': '快速',
  'about.fast.desc': '提供迅速執行與即時回應的客戶服務',
  'about.coreValue': '我們的核心價值',
  'about.coreValue.desc': '指引我們在貴金屬交易領域追求卓越的核心準則',
  'contact.sendUsMsg': '發送訊息給我們',
  'contact.fillOut': '請填寫以下表格，我們的團隊將於 24 小時內回覆您。',
  'contact.inqType': '查詢類型',
  'contact.genInq': '一般查詢',
  'contact.accSup': '帳戶支援',
  'contact.traSup': '交易支援',
  'contact.techSup': '技術支援',
  'contact.partner': '合作夥伴',
  'contact.fullname': '全名 *',
  'contact.email': '電郵地址 *',
  'contact.phone': '電話號碼',
  'contact.subject': '主旨 *',
  'contact.msg': '訊息 *',
  'contact.sendMsg': '發送訊息',
  'contact.whyUs': '為何選擇我們？',
  'contact.regSec': '受監管與安全',
  'contact.licAndReg': '受監管且安全的交易環境，並以先進保安措施保障您的投資。',
  'contact.expSup': '專家支援',
  'contact.proService': '專業交易專員 24/7 隨時協助您的交易需求與問題。',
  'contact.fastExe': '快速執行',
  'contact.lightFast': '閃電級下單執行，滑點極低，實現最佳交易表現。',
  'contact.glbNet': '全球市場',
  'contact.asscessToint': '連接國際貴金屬市場，具競爭力點差與深度流動性。',
  'contact.followUs': '追蹤我們的社交媒體：',
  'contact.contactOutPro': '如需交易支援、帳戶協助或一般查詢，請聯絡我們的專業團隊：',
  'contact.officeAddress': '辦公地址',
  'contact.bussHour': '辦公時間：週一至週五 9:00–18:00（GMT+8）',
  'contact.phoneSupp': '電話支援',
  'contact.mainOffice': '總辦事處',
  'contact.availableServices': '可提供的服務：',
  'contact.accOpenSup': '開戶支援',
  'contact.tradSup': '交易平台協助',
  'contact.genSup': '一般支援',
  'contact.emailSup': '電郵支援',
  'contact.responseTime': '回覆時間：',
  'contact.genInq24': '一般查詢：24 小時內',
  'contact.techSup24': '技術支援：4 小時內',
  'contact.accIss24': '帳戶問題：2 小時內',
  'contact.needImSup': '需要即時協助？',
  'contact.needImSup.desc': '我們的交易專員 24/7 隨時為您處理緊急交易事宜與帳戶支援。',
  'contact.callNow': '立即致電',
  'contact.sendEmail': '發送電郵',
  'contact.contactUs': '聯絡我們',
  'contact.getInTouch': '與我們的專業交易團隊聯繫；我們致力協助您在貴金屬交易中取得成功。',
  'contact.247Sup': '24/7 客服',
  'contact.247Sup.desc': '全天候為您的所有交易需求提供服務',
  'contact.dirLine': '直線專線',
  'contact.dirLine.desc': '直接與我們的交易專員對話',
  'contact.hkOffice': '香港辦事處',
  'contact.hkOffice.desc': '位處香港金融核心地帶',
  'platform.wco': '為何選擇我們的 MT5 平台？',
  'platform.etd': '體驗我們專為專業交易者設計的高級交易平台帶來的卓越感受。',
  'platform.rts': '準備好開始交易了嗎？',
  'platform.jto': '成千上萬交易者信任我們的平台以進行貴金屬交易',
  'platform.ola': '開立真實帳戶',
  'platform.tda': '試用模擬帳戶',
  'platform.dmt': '下載 MT5 平台',
  'platform.ayt': '透過多端 MT5 應用於任何裝置登入並管理您的交易帳戶',
  'platform.free': '免費',
  'platform.dn': '立即下載',
  'platform.sr': '系統需求',
  'platform.nh': '需要入門協助？',
  'platform.os': '我們的支援團隊隨時協助您設定並開始交易',
  'platform.ug': '使用指南',
  'platform.cs': '聯絡支援',
  'platform.si': '需要穩定的網絡連線',
  'platform.ptf': '強大交易功能',
  'platform.epg': '專為新手與專業交易者設計的專業級工具',
  'platform.ac': '高級圖表',
  'platform.pct': '專業圖表工具，內建 80+ 技術指標與多種時間框架，助您全面分析市場。',
  'platform.lfe': '閃電級執行',
  'platform.ull': '超低延遲交易，最快 0.01 秒執行，助您精準入場與出場。',
  'platform.ea': '智能交易（EA）',
  'platform.atc': '支援自訂 EA 與演算法策略的自動化交易能力。',
  'platform.rm': '風險管理',
  'platform.crm': '提供止損、止盈及倉位控制等全面風險管理工具。',
  'platform.mpa': '多平台存取',
  'platform.tsa': '桌面、網頁與行動平台無縫交易，帳戶同步存取。',
  'platform.gm': '全球市場',
  'platform.ati': '接入包括貴金屬、外匯、指數與大宗商品等國際市場。',
  'platform.etw': '體驗世界最先進的交易平台。以機構級技術與閃電級執行交易貴金屬、外匯與差價合約。',
  'platform.download': '下載 ',
  'platform.wd': '觀看示範',
  'platform.es': '執行速度',
  'platform.th': '交易時間',
  'platform.in': '交易品種',
  'platform.lt': '真實交易',
  'platform.ptt': '專業交易工具',
  'platform.aig': '為專業交易者與嚴謹投資者提供機構級工具',
  'platform.rtd': '即時數據',
  'platform.lmd': '即時市場數據與價格更新',
  'platform.pa': '價格提示',
  'platform.caf': '自訂價格波動與市場事件提示',
  'platform.this': '交易歷史',
  'platform.cth': '完整的交易歷史與績效分析',
  'platform.ec': '經濟日曆',
  'platform.suw': '緊貼重要經濟事件',
  'platform.mw': '市場報價',
  'platform.rtp': '所有可交易品種的即時報價與市場深度',
  'platform.om': '訂單管理',
  'platform.aot': '支援市價、限價、止損與移動止損等進階訂單',
  'platform.ta': '技術分析',
  'platform.cta': '提供自訂指標與繪圖工具的完整技術分析套件',
   'platform.ufe': '超快執行', 
 'platform.rtc': '我們的交易專家和技術專家團隊提供全天候客戶支援。',
 'platform.247a': '全天候24小時服務', 
 'platform.csp' : '競爭性價差',
 'platform.iia': '業界領先的價差和透明的定價，無任何隱藏費用或佣金',
 'platform.01pip': '0.1 點起',
 'platform.ffd': '適用於 Windows 10/11 的完整功能桌面應用程式',
'platform.nma': '具備完整功能的原生 macOS 應用程式',
'platform.mta': '適用於 Android 裝置的行動交易應用程式',
'platform.iai': 'iPhone 與 iPad 交易應用程式',

'hero.browseFAQ': '查看常見問題',
  'hero.contactSupport': '聯絡客服',

  'contactCTA.phoneTitle': '電話支援',
  'contactCTA.phoneDesc': '直接與我們的專員通話',
  'contactCTA.callNow': '立即致電',
  'contactCTA.emailTitle': '電郵支援',
  'contactCTA.emailDesc': '獲得詳細書面回覆',
  'contactCTA.sendMsg': '發送訊息',
  'contactCTA.chatTitle': '線上聊天',
  'contactCTA.chatDesc': '即時訊息支援',
  'contactCTA.available': '24小時全年無休',
  'contactCTA.startChat': '開始聊天',
  'contactCTA.title': '還需要幫助嗎？',
  'contactCTA.subtitle': '我們的專業客服團隊隨時為您提供協助。',

  'faq.tagline': '我們能如何協助您？',
  'faq.title': '常見問題',
  'faq.subtitle': '瀏覽我們的常見問題，快速找到您的答案。',
  'faq.categories': '分類',
  'faq.cantFind': '找不到想要的答案？',
  'faq.supportText': '若常見問題中沒有涵蓋，請聯絡我們的支援團隊。',
  'faq.contactSupport': '聯絡支援團隊',

  'faq.general': '一般問題',
  'faq.account': '帳戶',
  'faq.trading': '交易',
  'faq.platform': '平台',
  'faq.deposits': '入金與出金',
  'faq.security': '安全性',

  'faq.general.q1': 'GOLD LABEL GLOBAL LIMITED 是什麼公司？',
  'faq.general.a1': 'GOLD LABEL GLOBAL LIMITED 是一家位於香港的受監管貴金屬交易公司，透過 MT5 平台提供專業的黃金、白銀及其他貴金屬交易服務。',
  'faq.general.q2': '你們提供哪些交易產品？',
  'faq.general.a2': '我們提供多種貴金屬，包括現貨黃金 (XAU/USD)、現貨白銀 (XAG/USD)、鉑金、鈀金以及各類貴金屬期貨合約。',
  'faq.general.q3': '你們的交易時間是什麼時候？',
  'faq.general.a3': '市場開放時間為每週 5 天、每天 24 小時，從星期日美東時間下午 5 點至星期五下午 4 點，依循國際市場時間。',
  'faq.general.q4': '我的投資在貴公司是否安全？',
  'faq.general.a4': '是的，我們完全受監管並持有牌照。客戶資金與公司資金分開存放於安全銀行帳戶中，並享有完善保險保障。',

  'faq.account.q1': '如何開立交易帳戶？',
  'faq.account.a1': '您可在線上完成申請表、提交身份文件並進行首次入金，通常 1–2 個工作天即可完成。',
  'faq.account.q2': '最低入金金額是多少？',
  'faq.account.a2': '標準帳戶最低入金為 1,000 美元，我們也提供高端帳戶享有更多優惠。',
  'faq.account.q3': '我可以擁有多個交易帳戶嗎？',
  'faq.account.a3': '可以，您可開立多個不同貨幣或類型的帳戶，以配合不同策略與風險管理。',
  'faq.account.q4': '如何驗證我的帳戶？',
  'faq.account.a4': '請提供政府核發之身分證明（護照或駕照）及近三個月內的地址證明（如水電費單或銀行月結單）。',

  'faq.trading.q1': '最小交易手數是多少？',
  'faq.trading.a1': '大多數產品的最小交易單位為 0.01 手，方便靈活控制倉位與風險。',
  'faq.trading.q2': '你們提供多少槓桿？',
  'faq.trading.a2': '貴金屬交易最高槓桿為 1:100，助您擴大交易潛力，同時維持良好風險管理。',
  'faq.trading.q3': '有交易手續費嗎？',
  'faq.trading.a3': '我們採取點差制度，無額外手續費，點差透明無隱藏成本。',
  'faq.trading.q4': '可以使用自動交易策略嗎？',
  'faq.trading.a4': '可以，MT5 支援智能交易系統 (EA) 及自動化策略，您可自行開發或使用現有機器人。',

  'faq.platform.q1': '支援哪些交易平台？',
  'faq.platform.a1': '我們主要使用 MetaTrader 5 (MT5) 平台，支援 Windows、Mac、iOS、Android 及網頁版。',
  'faq.platform.q2': 'MT5 需要收費嗎？',
  'faq.platform.a2': 'MT5 完全免費下載使用，包含全部圖表與交易工具。',
  'faq.platform.q3': '可否在手機上交易？',
  'faq.platform.a3': '當然可以！MT5 行動版支援 iOS 與 Android，隨時隨地掌握市場。',
  'faq.platform.q4': '是否提供模擬帳戶？',
  'faq.platform.a4': '我們提供免費模擬帳戶與虛擬資金，方便練習與熟悉平台。',

  'faq.deposits.q1': '接受哪些入金方式？',
  'faq.deposits.a1': '支援銀行轉帳、信用卡 (Visa、MasterCard) 及多種電子支付方式，安全快捷。',
  'faq.deposits.q2': '入金多久可以到帳？',
  'faq.deposits.a2': '信用卡入金即時到帳，銀行轉帳約需 1–3 個工作天，電子支付一般數小時內完成。',
  'faq.deposits.q3': '是否收取入金手續費？',
  'faq.deposits.a3': '我們不收取入金費用，但您的銀行或支付機構可能會收取處理費。',
  'faq.deposits.q4': '如何提款？',
  'faq.deposits.a4': '請於客戶後台申請提款，資金將退回原入金方式，處理時間視支付渠道而定。',

  'faq.security.q1': '如何保護我的個人資料？',
  'faq.security.a1': '我們使用 256 位元 SSL 加密確保資料安全，並嚴格保護客戶隱私，不向第三方透露。',
  'faq.security.q2': '是否提供雙重驗證？',
  'faq.security.a2': '有的，建議啟用兩步驗證 (2FA) 以增加帳戶安全。',
  'faq.security.q3': '忘記密碼怎麼辦？',
  'faq.security.a3': '請使用登入頁的「忘記密碼」連結，我們會寄送安全重設郵件。',
  'faq.security.q4': '如何確保公平交易環境？',
  'faq.security.a4': '我們提供即時報價、無交易員干預，並遵守監管規範，確保公平透明。',

  'markets.specsTitle': '交易規則',
'markets.specsDisclaimer': '* 交易條件會因平台設定及市場流動性而調整。',
'markets.spreadTypeFloating': '浮動點差',
'markets.points': '點',
'markets.variableByMarket': '按市場變動',

'markets.table.symbol': '交易品種',
'markets.table.contractUnit': '合約單位',
'markets.table.minLot': '單筆最小交易量',
'markets.table.maxLot': '單筆最大交易量',
'markets.table.leverage': '槓桿',
'markets.table.spreadType': '點差類型',
'markets.table.avgSpread': '平均點差',
'markets.table.swapLong': '隔夜利息（多）',
'markets.table.swapShort': '隔夜利息（空）',


'markets.contractSections.contractSize.title': '合約大小',
'markets.contractSections.contractSize.items.xauusd.label': '黃金 (XAUUSD)',
'markets.contractSections.contractSize.items.xauusd.desc': '黃金交易標準合約大小',
'markets.contractSections.contractSize.items.xagusd.label': '白銀 (XAGUSD)',
'markets.contractSections.contractSize.items.xagusd.desc': '白銀交易標準合約大小',
'markets.contractSections.contractSize.items.gaucnh.label': 'GAUCNH',
'markets.contractSections.contractSize.items.gaucnh.desc': '離岸人民幣相關外匯交易標準合約大小',

'markets.contractSections.priceMove.title': '最小價格變動',
'markets.contractSections.priceMove.items.goldTick.label': '黃金最小跳動',
'markets.contractSections.priceMove.items.goldTick.desc': '最小價格變動單位',
'markets.contractSections.priceMove.items.silverTick.label': '白銀最小跳動',
'markets.contractSections.priceMove.items.silverTick.desc': '最小價格變動單位',
'markets.contractSections.priceMove.items.fxTick.label': '外匯最小跳動',
'markets.contractSections.priceMove.items.fxTick.desc': '貨幣對報價最小變動單位',

'markets.contractSections.settlement.title': '結算方式',
'markets.contractSections.settlement.items.type.label': '結算類型',
'markets.contractSections.settlement.items.type.value': '現金結算',
'markets.contractSections.settlement.items.type.desc': '無需實物交收',
'markets.contractSections.settlement.items.currency.label': '結算貨幣',
'markets.contractSections.settlement.items.currency.desc': '貴金屬產品以美元結算',
'markets.contractSections.settlement.items.fxQuote.label': '報價貨幣',
'markets.contractSections.settlement.items.fxQuote.desc': 'GAUCNH 以 CNH 作報價',

'markets.contractSections.positionLimits.title': '持倉限制',
'markets.contractSections.positionLimits.items.maxPosition.label': '最大持倉',
'markets.contractSections.positionLimits.items.maxPosition.desc': '每個帳戶每個產品限制',
'markets.contractSections.positionLimits.items.orderDistance.label': '掛單距離',
'markets.contractSections.positionLimits.items.orderDistance.desc': '距離市價的最小距離',
'markets.contractSections.positionLimits.items.execution.label': '執行模式',
'markets.contractSections.positionLimits.items.execution.value': '市價執行',
'markets.contractSections.positionLimits.items.execution.desc': '訂單會根據市場流動性執行',

'markets.days.monday': '星期一',
'markets.days.tuesday': '星期二',
'markets.days.wednesday': '星期三',
'markets.days.thursday': '星期四',
'markets.days.friday': '星期五',
'markets.days.saturday': '星期六',
'markets.days.sunday': '星期日',

'markets.hours.monThu': '06:00 - 04:59',
'markets.hours.friday': '06:00 - 04:57',
'markets.hours.closed': '休市',

'markets.holidays.newYear.date': '1月1日',
'markets.holidays.newYear.event': '元旦',
'markets.holidays.christmas.date': '12月25日',
'markets.holidays.christmas.event': '聖誕節',
'markets.holidays.independence.date': '7月4日',
'markets.holidays.independence.event': '美國獨立日',
'markets.holidays.thanksgiving.date': '11月24日',
'markets.holidays.thanksgiving.event': '感恩節',

'news.pageTitle': '財經新聞',
'news.pageDesc': '精選黃金、市場、利率與央行動向，支援繁中、簡中及英文內容切換。',
'news.searchPlaceholder': '搜尋新聞關鍵字',
'news.empty': '暫時未有符合條件的新聞',
'news.filter.all': '全部',
'news.filter.gold': '黃金',
'news.filter.markets': '市場',
'news.filter.rates': '利率',
'news.filter.centralBank': '央行',
'news.filter.logistics': '物流',

// License Page
  'license.hero.badge': '官方認證資質',
  'license.hero.title': '香港黃金交易所行員牌照',
  'license.hero.subtitle': 'GOLD Label Global Limited 持有香港黃金交易所10號行員資格，受官方認可及監管，為您的貴金屬交易提供最可靠的保障。',
  'license.hero.badge1': '官方持牌行員',
  'license.hero.badge2': '10號行員資格',
  'license.hero.badge3': '香港政府認可',

  'license.details.badge': '牌照詳情',
  'license.details.title': '我們的官方牌照',
  'license.details.subtitle': '正式持牌，受香港黃金交易所監管，為客戶提供最高標準的貴金屬交易服務',

  'license.image.label': '官方牌照文件',
  'license.image.placeholder': '牌照圖片',
  'license.image.desc': '香港黃金交易所官方行員牌照',
  'license.image.verified': '經香港黃金交易所官方認證',

  'license.member.label': '行員編號',
  'license.member.title': '香港黃金交易所行員',

  'license.info.title': '關於我們的行員資格',
  'license.info.desc1': 'GOLD Label Global Limited 是香港黃金交易所的正式行員，持有10號行員資格。香港黃金交易所是香港歷史最悠久、規模最大的貴金屬交易機構，成立超過100年，是全球最重要的黃金交易中心之一。',
  'license.info.desc2': '作為正式行員，我們嚴格遵守香港黃金交易所的所有規則及監管要求，確保每一筆交易均在透明、公平及安全的環境下進行，保障每位客戶的利益。',

  'license.info.org.label': '監管機構',
  'license.info.org.value': '香港黃金交易所（Chinese Gold & Silver Exchange Society）',
  'license.info.member.label': '行員編號',
  'license.info.member.value': '第 10 號行員',
  'license.info.jurisdiction.label': '監管地區',
  'license.info.jurisdiction.value': '香港特別行政區',
  'license.info.status.label': '牌照狀態',
  'license.info.status.value': '有效及合規',

  'license.features.title': '行員資格的意義',
  'license.features.official.title': '官方認可',
  'license.features.official.desc': '獲香港黃金交易所正式認可，符合所有監管要求及行業標準',
  'license.features.trading.title': '正規交易資格',
  'license.features.trading.desc': '持有合法貴金屬交易業務資格，可合規開展黃金白銀交易業務',
  'license.features.regulated.title': '受嚴格監管',
  'license.features.regulated.desc': '受香港黃金交易所嚴格監管，定期接受合規審查及審計',
  'license.features.international.title': '國際認受性',
  'license.features.international.desc': '香港黃金交易所行員資格在全球範圍內獲廣泛認可，具備國際公信力',
  'license.features.market.title': '市場準入',
  'license.features.market.desc': '可直接參與香港黃金交易所的交易市場，獲得最優質的市場流動性',
  'license.features.network.title': '行業網絡',
  'license.features.network.desc': '成為龐大行業網絡的一部分，與其他正規金融機構建立可靠合作關係',

  'license.exchange.badge': '關於香港黃金交易所',
  'license.exchange.title': '香港黃金交易所 — 逾百年傳承',
  'license.exchange.desc1': '香港黃金交易所（Chinese Gold & Silver Exchange Society）成立於1910年，是香港歷史最悠久的貴金屬交易機構。逾百年來，交易所一直是香港乃至亞洲貴金屬市場的核心機構。',
  'license.exchange.desc2': '交易所設立嚴格的會員資格制度，只有符合資格、通過審核的企業才能成為正式行員。我們公司成功獲得10號行員資格，充分證明了我們的專業實力及信譽。',

  'license.exchange.stat1.value': '1910',
  'license.exchange.stat1.label': '交易所成立年份',
  'license.exchange.stat2.value': '100+',
  'license.exchange.stat2.label': '年歷史傳承',
  'license.exchange.stat3.value': 'HK$800億',
  'license.exchange.stat3.label': '日均交易額',
  'license.exchange.stat4.value': '全球認可',
  'license.exchange.stat4.label': '國際公信力',

  'license.exchange.img.caption': '香港黃金交易所',
  'license.exchange.img.sub': 'Chinese Gold & Silver Exchange Society',
  'license.exchange.badge.number': '第10號行員',
  "hero.cta.accountOpening": "開戶流程",
  "hero.cta.depositWithdraw": "出入金流程"
,
  "androidDownload.title": "下載 MetaTrader 5",
  "androidDownload.description": "系統會自動為你前往 Google Play。如果你的裝置無法使用 Google Play，亦可以直接下載 APK。",
  "androidDownload.autoRedirect": "{{seconds}} 秒後自動前往 Google Play",
  "androidDownload.openGooglePlay": "開啟 Google Play",
  "androidDownload.downloadApk": "直接下載 APK",
  "androidDownload.hint": "如果 Google Play 未能開啟，請點擊「直接下載 APK」。",
  'windowsDownload.pageTitle': 'Windows MT5 安裝下載',
  'windowsDownload.pageDesc': '請在彈頁中選擇適合您的下載版本。',
  'windowsDownload.badge': 'Windows MT5 安裝下載',
  'windowsDownload.title': '請選擇適合您的安裝包',
  'windowsDownload.description': '請選擇適合您的 Windows MT5 安裝包。金利寶流暢穩定版適合中國內地及香港用戶優先使用；如需使用原有官方安裝包，亦可選擇第二項。',
  'windowsDownload.smoothTitle': '1、金利寶流暢穩定版',
  'windowsDownload.smoothDesc': '適合中國內地 / 香港 Windows 用戶，建議優先下載此版本。其他地區用戶如遇官方安裝包不便，也可使用。',
  'windowsDownload.smoothButton': '下載金利寶流暢穩定版',
  'windowsDownload.officialTitle': '2、直達邁達克官方安裝包',
  'windowsDownload.officialDesc': '原有下載連接。大陸地區 Windows 用戶偶爾會出現無法安裝情況，其他地區客戶不受影響。',
  'windowsDownload.officialButton': '下載官方安裝包',

  // Economic calendar explorer
  'calendar.hongKongTime': '香港時間（GMT+8）',
  'calendar.previousDays': '前 7 日',
  'calendar.nextDays': '後 7 日',
  'calendar.today': '今日',
  'calendar.jumpToDate': '跳至日期',
  'calendar.completeView': '完整日曆',
  'calendar.allDays': '全部 7 日',
  'calendar.events': '事件',
  'calendar.impactAll': '全部重要性',
  'calendar.impactHigh': '高',
  'calendar.impactMedium': '中',
  'calendar.impactLow': '低',
  'calendar.searchPlaceholder': '搜尋事件、國家或貨幣',
  'calendar.eventsFound': '個事件顯示中',
  'calendar.lastUpdated': '最後更新',
  'calendar.loadError': '暫時未能載入經濟日曆。',
  'calendar.noEvents': '此檢視沒有符合條件的經濟事件。',
  'calendar.tryAnotherDate': '請選擇其他日期或清除篩選條件。',
  'calendar.time': '時間',
  'calendar.impact': '重要性',
  'calendar.released': '已公佈',
  'calendar.pending': '待公佈',
  'calendar.disclaimer': '日曆時間以香港時間顯示；數據可能修訂，內容只供參考。',
  'news.tab.newsDesc': '最新市場新聞、黃金分析及教育內容',
  'news.tab.calendarDesc': '查看前後日期的重要經濟事件及公佈數據',
  'news.autoRefresh': '新聞資料會自動更新',

  'news.tabs.news': '新聞',
  'news.tabs.calendar': '經濟日曆',

};

export default common;
